import { useAppSelector } from '@store';
import { IconAgreements, IconDown, IconLoader, IconUp } from '@ui/src';
import useAgreements from '../hooks/use-agreements';
import { AgreementsTypes } from '../types';
import AgreementsHeader from '../../../../components/common/agreements/agreements-header';
import AgreementContent from '../../../../components/common/agreements/agreements-content';

import cn from '../styles.module.css';

const Agreements = ({ customerId, type }: AgreementsTypes) => {
  const { agreements, usignedAgreements } = useAppSelector(
    (state) => state.customerDocuments,
  );

  const {
    agreementsIsLoading,
    usignedAgreementsIsLoading,
    setAgreementsVisible,
    agreementsVisible,
    agreementsList,
    downloadInProgress,
    downloadIsFetching,
    downloadedFileId,
    getAgreementFileAction,
  } = useAgreements({
    agreements,
    usignedAgreements,
    customerId,
  });

  let agreementsContent;

  if (agreementsIsLoading || usignedAgreementsIsLoading) {
    agreementsContent = (
      <div className={cn.agreementsLoader}>
        <IconLoader />
      </div>
    );
  } else {
    agreementsContent = (
      <>
        <button
          type="button"
          className={cn.agreementsButton}
          onClick={() => setAgreementsVisible(!agreementsVisible)}
        >
          <div className={cn.agreementsButtonLeft}>
            <span>
              <IconAgreements />
            </span>
            <span>Agreements</span>
          </div>
          <div className={cn.agreementsButtonIcon}>
            {agreementsVisible ? <IconUp /> : <IconDown />}
          </div>
        </button>
        {agreementsVisible && (
          <div className={cn.agreementsContent}>
            <AgreementsHeader />
            {Object.keys(agreementsList).map((item) => (
              <AgreementContent
                key={item}
                agreementGroup={agreementsList[item]}
                type={type}
                customerId={customerId}
                downloadInProgress={downloadInProgress}
                downloadIsFetching={downloadIsFetching}
                getAgreementFileAction={getAgreementFileAction}
                downloadedFileId={downloadedFileId}
              />
            ))}
          </div>
        )}
      </>
    );
  }

  return agreementsContent;
};

export default Agreements;
